import React from 'react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer id="contact" className="bg-gray-900 text-gray-300 py-16 border-t border-gray-800" data-id="element-72">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-73">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12" data-id="element-74">
          {/* Column 1: Company */}
          <div data-id="element-75">
            <a href="#" className="text-2xl font-heading font-bold text-white tracking-tight mb-6 inline-block" data-id="element-76">
              3techno <span className="text-teal" data-id="element-77">Digital</span>
            </a>
            <address className="not-italic text-sm space-y-2 text-gray-400" data-id="element-78">
              <p data-id="element-79">3techno Digital LLC</p>
              <p data-id="element-80">Claymont, Delaware, USA</p>
              <p className="pt-2" data-id="element-81">
                <a href="mailto:fahad@3techno.com" className="hover:text-white transition-colors" data-id="element-82">
                  fahad@3techno.com
                </a>
              </p>
              <p data-id="element-83">
                <a href="https://3techno.com" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" data-id="element-84">
                  3techno.com
                </a>
              </p>
            </address>
          </div>

          {/* Column 2: Services */}
          <div data-id="element-85">
            <h4 className="text-white font-bold font-heading mb-6 uppercase tracking-wider text-sm" data-id="element-86">
              Services
            </h4>
            <ul className="space-y-3 text-sm text-gray-400" data-id="element-87">
              <li data-id="element-88">
                <a href="#services" className="hover:text-white transition-colors" data-id="element-89">
                  Ecommerce Development
                </a>
              </li>
              <li data-id="element-90">
                <a href="#services" className="hover:text-white transition-colors" data-id="element-91">
                  Platform Migration
                </a>
              </li>
              <li data-id="element-92">
                <a href="#services" className="hover:text-white transition-colors" data-id="element-93">
                  SEO & Digital Marketing
                </a>
              </li>
              <li data-id="element-94">
                <a href="#services" className="hover:text-white transition-colors" data-id="element-95">
                  Conversion Rate Optimization
                </a>
              </li>
              <li data-id="element-96">
                <a href="#services" className="hover:text-white transition-colors" data-id="element-97">
                  Social Media Management
                </a>
              </li>
            </ul>
          </div>

          {/* Column 3: Connect */}
          <div data-id="element-98">
            <h4 className="text-white font-bold font-heading mb-6 uppercase tracking-wider text-sm" data-id="element-99">
              Connect
            </h4>
            <ul className="space-y-3 text-sm text-gray-400" data-id="element-100">
              <li data-id="element-101">
                <a href="https://linkedin.com/company/3-techno" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" data-id="element-102">
                  LinkedIn
                </a>
              </li>
              <li data-id="element-103">
                <a href="https://linkedin.com/in/fahadjahanzeb" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" data-id="element-104">
                  LinkedIn (Fahad)
                </a>
              </li>
              <li data-id="element-105">
                <a href="#" className="hover:text-white transition-colors" data-id="element-106">
                  Instagram
                </a>
              </li>
              <li data-id="element-107">
                <a href="#" className="hover:text-white transition-colors" data-id="element-108">
                  Facebook
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-800 text-center md:text-left flex flex-col md:flex-row justify-between items-center text-xs text-gray-500" data-id="element-109">
          <p data-id="element-110">
            Copyright {currentYear} 3techno Digital LLC. All rights reserved.
          </p>
          <div className="mt-4 md:mt-0 space-x-4" data-id="element-111">
            <a href="#" className="hover:text-white transition-colors" data-id="element-112">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-113">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}